<template>
  <div class="row">
    <div class="span8 list-main">
      <h1 class="list-title">问答区
        <small>{{ tag ? '标签：' + tag : (pagelistquery.lable ? pagelistquery.lable : '') }}</small>
      </h1>
      <ul class="tabs-nav">
        <li v-if="tag" :class="{ active: true }" class="tag-chip" @click="exitTag">{{ tag }} <span class="tag-clear">✕</span></li>
        <li :class="{ active: !tag && pagelistquery.lable === '' }" @click="changelable('')">全部</li>
        <li v-for="item in lables" :key="item" :class="{ active: !tag && pagelistquery.lable === item }" @click="changelable(item)">{{ item }}</li>
      </ul>
      <ul class="articles">
        <li class="article-entry" v-for="item in tableData" :key="item.help_id">
          <h4 class="entry-title">
            <router-link :to="`/helpcontent/${item.help_id}`">{{ item.help_title }}</router-link>
          </h4>
          <div class="entry-meta">
            <span>🕐 {{ item.createtime | dataFormat }}</span>
            <span>作者：{{ item.nickname || '匿名同学' }}</span>
            <span>👁 {{ item.help_read_num }}</span>
          </div>
        </li>
      </ul>
      <div class="pagination-wrap">
        <el-pagination
          layout="prev, pager, next"
          :total="pagelistquery.total"
          :page-size="10"
          @current-change="getlist"
        ></el-pagination>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <oldstuffhot-widget />
    </div>
  </div>
</template>

<script>
import carouselWidget from '@/components/carousel.vue'
import oldstuffhotWidget from '@/components/oldstuffhot.vue'
import { getHelpList, getLable } from '@/api'

export default {
  name: 'Help',
  components: { carouselWidget, oldstuffhotWidget },
  props: { tag: { type: String, default: '' } },
  data() {
    return {
      lables: [],
      tableData: [],
      pagelistquery: { lable: '', tag: this.tag || '', page: 1, total: 0 }
    }
  },
  watch: {
    // 深链进入 /help/:tag 或退出标签路由时，同步筛选条件并重新拉取
    '$route.params.tag'() {
      this.pagelistquery.tag = this.tag || ''
      this.getlist(1)
    }
  },
  created() {
    this.getlables()
    this.getlist(1)
  },
  methods: {
    getlables() {
      getLable('问答分类').then((res) => {
        this.lables = JSON.parse(res.data[0].lable) || []
      })
    },
    getlist(page) {
      this.pagelistquery.page = page
      getHelpList({ ...this.pagelistquery, pagesize: 10 }).then((res) => {
        this.tableData = res.data || []
        this.pagelistquery.total = res.count || 0
      })
    },
    // 退出标签过滤（回到无标签路由，watch 会自动重新拉取）
    exitTag() {
      this.pagelistquery.tag = ''
      if (this.tag) this.$router.push('/help')
      else this.getlist(1)
    },
    // 点「全部」或任一分类：清空标签（若处于标签路由则先退出），再按分类拉取
    changelable(lable) {
      this.pagelistquery.lable = lable
      if (this.tag) {
        this.exitTag()
      } else {
        this.getlist(1)
      }
    }
  }
}
</script>

<style scoped>
.tabs-nav .tag-chip { color: #0E7490; border-bottom-color: #0E7490; }
.tabs-nav .tag-clear { margin-left: 4px; font-size: 12px; color: #999; }
</style>
